/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ToolNameplateExportBody = {
    abbreviations: Array<string>;
    nameplate_size: ToolNameplateExportBody.nameplate_size;
};
export namespace ToolNameplateExportBody {
    export enum nameplate_size {
        TINY = 'tiny',
        SMALL = 'small',
        LARGE = 'large',
    }
}

